import { render, staticRenderFns } from "./map-elements-list.vue?vue&type=template&id=10479172&scoped=true&"
import script from "./map-elements-list.vue?vue&type=script&lang=js&"
export * from "./map-elements-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10479172",
  null
  
)

export default component.exports